module.exports = "<h1>Welcome to eventpic</h1>"